import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import NavigationSettings from './navigation-settings.service';
import { ProductTypeEnum } from '../../model/enums/ProductTypeEnum';

@Component({
  selector: 'app-navigation-component',
  templateUrl: './navigation-component.html',
  styleUrls: ['./navigation-component.css'],
})
export class NavigationComponent implements OnInit {
  @Input()
  productType: ProductTypeEnum;

  @Output()
  navigationStepsReady = new EventEmitter<void>();

  constructor(public navigationSettings: NavigationSettings) {
  }

  ngOnInit(): void {
    this.navigationSettings.setStepsByProductType(this.productType);
    this.navigationStepsReady.emit();
  }
}
